/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCrown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13.001 6.732a2 2 0 1 0-2.002 0L8.17 11.579 4.6 9.199A2 2 0 1 0 3 10a1 1 0 0 0 .024.217l2 9A1 1 0 0 0 6 20h12a1 1 0 0 0 .976-.783l2-9c.016-.072.024-.145.024-.217a2 2 0 1 0-1.601-.801l-3.57 2.38zm-3.637 6.772L12 8.984l2.636 4.52a1 1 0 0 0 1.419.328l2.429-1.62L17.198 18H6.802l-1.286-5.787 2.43 1.62a1 1 0 0 0 1.418-.33z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCrown as Crown };
